"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _globals = require("~/utils/globals");
const up = async (knex)=>{
    await knex.schema.createTable(_globals.MetaTable.MAP_VIEW, (table)=>{
        table.string('fk_view_id', 20).primary();
        table.foreign('fk_view_id').references(`${_globals.MetaTable.VIEWS}.id`);
        table.string('base_id', 20);
        table.foreign('base_id').references(`${_globals.MetaTableOldV2.BASES}.id`);
        table.string('project_id', 128);
        table.foreign('project_id').references(`${_globals.MetaTableOldV2.PROJECT}.id`);
        table.string('uuid');
        table.string('title');
        table.string('fk_geo_data_col_id', 20);
        table.foreign('fk_geo_data_col_id').references(`${_globals.MetaTable.COLUMNS}.id`);
        table.text('meta');
        table.dateTime('created_at');
        table.dateTime('updated_at');
    });
    await knex.schema.createTable(_globals.MetaTable.MAP_VIEW_COLUMNS, (table)=>{
        table.string('id', 20).primary().notNullable();
        table.string('base_id', 20);
        table.string('project_id', 128);
        table.string('fk_view_id', 20);
        table.foreign('fk_view_id').references(`${_globals.MetaTable.MAP_VIEW}.fk_view_id`);
        table.string('fk_column_id', 20);
        table.foreign('fk_column_id').references(`${_globals.MetaTable.COLUMNS}.id`);
        table.string('uuid');
        table.string('label');
        table.string('help');
        table.boolean('show');
        table.float('order');
        table.timestamps(true, true);
    });
};
const down = async (knex)=>{
    await knex.schema.dropTable(_globals.MetaTable.MAP_VIEW);
    await knex.schema.dropTable(_globals.MetaTable.MAP_VIEW_COLUMNS);
};
